import React from 'react';
import { Typography } from '@kiiwi/ui';

import { CardHcd } from '@maiia/model/generated/model/api-patient/api-patient';
import { useRouter } from 'next/router';
import FontAwesomeIcon from '@/components/atoms/FontawesomeIcon/FontawesomeIcon';
import { Trans } from '@/src/i18n';
import { dayjsWithTimezone } from '@/src/utils';
import { DEFAULT_TIMEZONE, TELECONSULTATION } from '@/src/constants';
import { useFirstAvailability } from '@/src/hooks';

interface Props {
  item: Required<CardHcd>;
}

const SearchCardTlcUpcomingCTA = ({ item }: Props) => {
  const router = useRouter();

  const dayjsTZ = dayjsWithTimezone(
    item.settings?.timeZone || DEFAULT_TIMEZONE,
  );
  const firstAvailability = useFirstAvailability(item, TELECONSULTATION);
  const timeslot = dayjsTZ(firstAvailability).format('HH:mm');

  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    router.push(`${item.url}?centerId=${item.center?.id}`);
    e.stopPropagation();
  };

  return (
    <div
      className="flex w-full max-w-[121px] flex-1 cursor-pointer flex-col items-center justify-center rounded-sm bg-surface-lighter p-2 sm:max-w-[216px]"
      onClick={e => handleClick(e)}
    >
      <div className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-primary-enabled">
        <FontAwesomeIcon name="video:solid" className="h-4 w-4 text-white" />
      </div>
      <Typography className="mt-1 max-w-[102px] text-center text-lg font-semibold text-neutral-secondary">
        <Trans
          i18nKey="next_appointment_at_2"
          values={{ timeslot }}
          components={[
            <span key="appointmentAt" className="text-sm" />,
            <span key="timeslot" className="text-base" />,
          ]}
        />
      </Typography>
    </div>
  );
};

export default SearchCardTlcUpcomingCTA;
